import { memo, useMemo } from 'react'

import { ApplicationDocuments } from 'commons/types/DTO/bank/applications/manage/ClientUploadedDocuments'
import { TableDataQa } from 'commons/types/enums'
import { Layer } from 'ui/components/Layer'
import { DataSourceItem, Table } from 'ui/components/Table'

import { DocumentsTableProps } from './DocumentsTableProps'
import { columns } from './columns'

export const DocumentsTable = memo((props: DocumentsTableProps) => {
  const { webPage, applicationClientUploadedDocument, readonly, onDeleteDocument, loading } = props

  const mappedDocumentsTable: DataSourceItem<ApplicationDocuments>[] = useMemo(
    () =>
      applicationClientUploadedDocument.documents.map((el) => ({
        item: el
      })),
    [applicationClientUploadedDocument]
  )

  return (
    <Layer rounded shadowed stretch>
      <div id={`applicationDocumentsContainer_${applicationClientUploadedDocument.companyUid}`} />
      <Table<ApplicationDocuments>
        dataQa={TableDataQa.BP_ONBOARDING_APPLICATION_DOCUMENTS_LIST}
        noDataMessage="No Documents Necessary"
        loading={loading}
        columns={columns(webPage, applicationClientUploadedDocument, readonly, onDeleteDocument)}
        dataSource={mappedDocumentsTable}
      />
    </Layer>
  )
})
